import { useOutletContext } from "react-router-dom";
import TINNRLayout from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { useEffect } from "react";
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import ContactForm from "@/components/ContactForm";
import PageBanner from "@/components/PageBanner";
import { isEmpty } from "lodash";
import EResourceType from "@/cms/enums/EResourceType";
import ContentRenderer from "@/components/ContentRenderer";
import ContentInnerHeader from "@/components/ContentInnerHeader";


const INNR_003 = ( props:TINNRLayout ) => {
    console.log("INNR_003.rendered: ", props);

    const { contentId, siteSettingPayload, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();

    useEffect(() => { return () => { _showLoader() }},[])
    useEffect(() => { setTimeout(() => { _hideLoader(); }, 100) },[contentId])
    
    if ( !props.contentDetailPayload?.languageVersions || isEmpty(props.contentDetailPayload?.languageVersions) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetailPayload.languageVersions);
    const pageContactFormHeader = metaDataLanguageVersion("pageContactFormHeader", siteSettingPayload.languageVersions);
    const pageContactFormDescription = metaDataLanguageVersion("pageContactFormDescription", siteSettingPayload.languageVersions);

    return (
        <>
            <PageBanner title={languageVersion?.name} resources={props.contentDetailPayload.resources} resourceType={EResourceType.PARALLAX} />
            <div className="services-details-area ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <ContentInnerHeader payload={props.contentDetailPayload} metaInformationEnabled />
                        </div>

                        <div className="col-12">
                            <ContentRenderer
                                languageVersions={props.contentDetailPayload.languageVersions}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-100">
                <div className="contact-form">
                    <div className="contact-title">
                        <h2>{pageContactFormHeader}</h2>
                        <p>{pageContactFormDescription}</p>
                    </div>
                    <ContactForm allowSendURL />
                </div>
            </div>
      </>
    );
}

export default INNR_003;
